{
  "attribution.title": "Атрибуция",
  "common.close": "Закрыть",
  "common.feature": "Объект {id}",
  "identify.close": "Закрыть результат идентификации",
  "identify.dialogLabel": "Результат идентификации",
  "identify.failed": "Идентификация не выполнена",
  "identify.identifying": "Идентификация",
  "identify.noFeature": "Объекты не найдены",
  "identify.title": "Идентификация",
  "layers.collapse": "Свернуть {title}",
  "layers.defaultTitle": "Слой",
  "layers.expand": "Развернуть {title}",
  "layers.hideAll": "Нет",
  "layers.hideAllTitle": "Скрыть все слои",
  "layers.legendCollapse": "Свернуть легенду {title}",
  "layers.legendExpand": "Развернуть легенду {title}",
  "layers.loading": "Загрузка слоёв",
  "layers.panelLabel": "Панель слоёв",
  "layers.showAll": "Все",
  "layers.showAllTitle": "Показать все слои",
  "layers.title": "Слои",
  "measure.area": "Измерить площадь",
  "measure.close": "Закрыть измерение",
  "measure.distance": "Измерить расстояние",
  "search.failed": "Поиск не выполнен",
  "search.label": "Поиск",
  "search.noResults": "Ничего не найдено",
  "search.placeholder": "Начните ввод",
  "search.searching": "Поиск",
  "tools.identify": "Идентифицировать объекты",
  "zoom.home": "Вернуться к начальному охвату",
  "zoom.in": "Приблизить",
  "zoom.out": "Отдалить"
}
